import { Button, HStack, Select, Spacer, Text, VStack } from "@chakra-ui/react";
import { useCompetitionsFromBackend } from "./Services/CompetitionService";
import { GET } from "./api/BackendApi";
import { useGlobalContext } from "./Layout/GlobalState";
import { useCallback } from "react";

export function Home() {
  const competitionHandler = useCompetitionsFromBackend();
  const globalContext = useGlobalContext();

  const fetchCompetition = useCallback(
    (competitionTag: string) => {
      const competitions = competitionHandler.competitions.filter(
        (c) => c.tag === competitionTag
      );

      if (competitions.length > 0) {
        GET.getCompetitionWithDisciplinesAndStartgroups(
          competitions[0].id
        ).then((response) => {
          globalContext.setCompetition(response);
        });
      }
    },
    [globalContext.setCompetition, competitionHandler.competitions]
  );

  return (
    <HStack width={"100%"}>
      <Spacer />
      <VStack
        bg={"white"}
        spacing={3}
        align={"left"}
        padding={"100px"}
        width={"80%"}
        boxShadow={"lg"}
      >
        <Text fontSize={"24px"}>Välj tävling:</Text>
        <HStack>
          <Select
            placeholder="Välj tävling"
            size={"lg"}
            fontSize={"24px"}
            width={"fit-content"}
            bg="gray.200"
            onChange={(selected) => {
              fetchCompetition(selected.target.value);
            }}
            value={competitionHandler.getSelectedCompetition()?.tag}
          >
            {competitionHandler.competitions.map((c) => {
              return (
                <option key={"competition_" + c.tag} value={c.tag}>
                  {c.tag}
                </option>
              );
            })}
          </Select>
          {globalContext.competition?.tag && (
            <Button
              marginLeft={"40px"}
              onClick={() => {
                const competitionTag = globalContext.competition?.tag;
                if (competitionTag) {
                  fetchCompetition(competitionTag);
                }
              }}
              colorScheme="blue"
            >
              Ladda om
            </Button>
          )}
        </HStack>
      </VStack>
      <Spacer />
    </HStack>
  );
}
